// Replace with your actual Google Analytics 4 Measurement ID
// You can find this in your Google Analytics dashboard under Admin > Data Streams
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-EMKFHC980M';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    // Load the Google Analytics script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}', {
        page_title: document.title,
        page_location: window.location.href,
      });
    `;
    document.head.appendChild(script2);

    // Set up global gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track user interactions specific to the Learn Japanese app
export const trackLearningEvent = (action, content_type, content_id) => {
  trackEvent(action, 'Learning', `${content_type}:${content_id}`);
};

// Track audio playback
export const trackAudioPlay = (content_type, content_id) => {
  trackEvent('audio_play', 'Learning', `${content_type}:${content_id}`);
};

// Track user authentication events
export const trackAuthEvent = (action, method = 'google') => {
  trackEvent(action, 'Authentication', method);
};

// Track admin actions
export const trackAdminEvent = (action, content_type, content_id) => {
  trackEvent(action, 'Admin', `${content_type}:${content_id}`);
};

// Track navigation events
export const trackNavigation = (section) => {
  trackEvent('navigate', 'Navigation', section);
};
